export const ORDER_ROUTING = [
    {
        path: '/order',
        name: 'order',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Đơn hàng', pathName: 'order', icon: 'fa fa-bar-chart' },
        ] },
        component: () => import('./Order.vue'),
        redirect: { name: 'order-index' },
        children: [
            {
                path: '/don-hang.html',
                name: 'order-index',
                component: () => import('./components/main-order/MainOrder.vue'),
            },
            {
                path: '/don-hang/:orderId',
                name: 'order-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết đơn hàng', pathName: 'order-detail', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/detail-order/DetailOrder.vue'),
            },
            {
                path: '/khieu-nai/:orderId',
                name: 'order-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại đơn hàng', pathName: 'order-complain', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/complain-order/ComplainOrder.vue'),
            },
            {
                path: '/khieu-nai/:orderId/:complainId',
                name: 'detail-order-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại đơn hàng', pathName: 'order-complain', icon: 'fa fa-bar-chart' },
                    ]
                },
                component: () => import('./components/complain-order/ComplainOrder.vue')
            }
        ],
    },
];
